<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 108.741 97.812"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.822"
        y1="0.868"
        x2="0.355"
        y2="0.007"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#de4551" stop-opacity="0" />
        <stop offset="1" stop-color="#de4551" />
      </linearGradient>
      <linearGradient id="linear-gradient-2" x1="0.5" y1="0" x2="0.5" y2="1" xlink:href="#linear-gradient" />
    </defs>
    <g id="Group_83" data-name="Group 83" transform="translate(0 -25.728)">
      <path
        id="Path_656"
        data-name="Path 656"
        d="M77.483,51.48c-14.675-5.742-35-3.56-46.228,6.692-7.93,7.239-1.792,9.3,3.614,22.549C38.781,90.308,0,88.988,0,106.312c0,20.028,28.088,16.231,38.511,18.524,15.936,3.505,29.839,16.617,46.866,14.889,14.823-1.5,20.474-13.137,22.536-26.472,3.84-24.844-5.592-52.054-30.431-61.773Z"
        transform="translate(0 -17.83)"
        fill="url(#linear-gradient)"
      />
      <g id="Group_82" data-name="Group 82" transform="translate(6.499 25.728)">
        <g id="Group_73" data-name="Group 73">
          <g id="Group_72" data-name="Group 72">
            <g id="Group_70" data-name="Group 70" transform="translate(9.066 5.672)">
              <path
                id="Path_657"
                data-name="Path 657"
                d="M162.755,97.624a15.188,15.188,0,0,0-28.075-8.039H80.414a2.122,2.122,0,0,0-2.124,2.124v71.238a2.122,2.122,0,0,0,2.124,2.124h71.238a2.122,2.122,0,0,0,2.124-2.124V111.485a15.188,15.188,0,0,0,8.979-13.861Z"
                transform="translate(-77.227 -76.063)"
                opacity="0.1"
                fill="url(#linear-gradient-2)"
                style="isolation: isolate"
              />
              <path
                id="Path_658"
                data-name="Path 658"
                d="M153.776,93.226v71.238a2.122,2.122,0,0,1-2.124,2.124H80.414a2.122,2.122,0,0,1-2.124-2.124V93.226A2.122,2.122,0,0,1,80.414,91.1h71.238A2.122,2.122,0,0,1,153.776,93.226Z"
                transform="translate(-77.227 -82.89)"
                fill="#fff"
              />
              <path
                id="Path_659"
                data-name="Path 659"
                d="M128.555,312.259H115.973a1.062,1.062,0,0,1-1.062-1.062V285.253a1.062,1.062,0,0,1,1.062-1.062h12.582a1.062,1.062,0,0,1,1.062,1.062V311.2A1.062,1.062,0,0,1,128.555,312.259Z"
                transform="translate(-106.071 -234.97)"
                fill="#fff"
              />
              <path
                id="Path_660"
                data-name="Path 660"
                d="M128.555,312.259H115.973a1.062,1.062,0,0,1-1.062-1.062V285.253a1.062,1.062,0,0,1,1.062-1.062h12.582a1.062,1.062,0,0,1,1.062,1.062V311.2A1.062,1.062,0,0,1,128.555,312.259Z"
                transform="translate(-106.071 -234.97)"
                fill="#f0324c"
              />
              <g id="Group_66" data-name="Group 66" transform="translate(11.893 52.79)">
                <path
                  id="Path_661"
                  data-name="Path 661"
                  d="M142.787,303.119H130.345a1.062,1.062,0,0,1,0-2.124h12.442a1.062,1.062,0,0,1,0,2.124Z"
                  transform="translate(-129.283 -300.995)"
                  fill="#2f3042"
                />
              </g>
              <path
                id="Path_662"
                data-name="Path 662"
                d="M78.288,222.576,89.932,229.4l10.027-2.633a1.062,1.062,0,0,1,1.027.282l10.652,10.833,12.821-5.742a1.062,1.062,0,0,1,1.146,1.757l-12.117,10.96a1.062,1.062,0,0,1-1.309.091l-12.241-8.306L88.644,244.27a1.062,1.062,0,0,1-1.139.032l-9.218-5.5Z"
                transform="translate(-77.225 -186.441)"
                fill="#f0324c"
              />
              <path
                id="Path_663"
                data-name="Path 663"
                d="M133.666,296.272l-8.948,6.042a1.063,1.063,0,0,1-.629.181v-5.161a1.062,1.062,0,0,1,1.062-1.062Z"
                transform="translate(-113.3 -244.485)"
                fill="#fff"
              />
              <g id="Group_67" data-name="Group 67" transform="translate(0 34.282)">
                <path
                  id="Path_664"
                  data-name="Path 664"
                  d="M108.838,239.323a2.122,2.122,0,0,1-1.193-.368L96,231.053l-10.7,7.224a2.131,2.131,0,0,1-2.277.064l-9.736-5.813V213.85l12.863,7.539,9.6-2.521a2.127,2.127,0,0,1,2.054.565l10.135,10.307,12.147-5.44a2.124,2.124,0,0,1,2.293,3.513l-12.117,10.96a2.12,2.12,0,0,1-1.424.55ZM96,228.489l12.836,8.709,12.117-10.96h0l-13.494,6.044L96.29,220.922l-10.453,2.745-10.426-6.111v13.766l8.7,5.195Z"
                  transform="translate(-73.287 -213.85)"
                  fill="#2f3042"
                />
              </g>
              <path
                id="Path_665"
                data-name="Path 665"
                d="M78.29,115.182h75.486v2.925H78.29Z"
                transform="translate(-77.227 -101.856)"
                fill="#2f3042"
              />
              <path
                id="Path_666"
                data-name="Path 666"
                d="M234.368,116.164H221.3a1.062,1.062,0,0,1-1.062-1.062v-24H235.43v24A1.062,1.062,0,0,1,234.368,116.164Z"
                transform="translate(-189.03 -82.887)"
                fill="#f0324c"
              />
              <path
                id="Path_667"
                data-name="Path 667"
                d="M247.12,91.1h3.772v25.063H247.12Z"
                transform="translate(-210.201 -82.89)"
                fill="#fff"
              />
              <g id="Group_68" data-name="Group 68" transform="translate(55.765 64.681)">
                <path
                  id="Path_668"
                  data-name="Path 668"
                  d="M349.365,362.317H336.916a1.062,1.062,0,0,1-1.062-1.062v-3.213a1.062,1.062,0,0,1,1.062-1.062h12.449a1.062,1.062,0,0,1,1.062,1.062v3.213a1.062,1.062,0,0,1-1.062,1.062Z"
                  transform="translate(-335.854 -356.98)"
                  fill="#f0324c"
                />
                <path
                  id="Path_669"
                  data-name="Path 669"
                  d="M349.365,396.557H336.916a1.062,1.062,0,0,1-1.062-1.062v-3.213a1.062,1.062,0,0,1,1.062-1.062h12.449a1.062,1.062,0,0,1,1.062,1.062v3.213A1.062,1.062,0,0,1,349.365,396.557Z"
                  transform="translate(-335.854 -383.948)"
                  fill="#f0324c"
                />
              </g>
              <path
                id="Path_670"
                data-name="Path 670"
                d="M370.3,301.551h-6.8a1.062,1.062,0,0,1-1.062-1.062v-6.8a1.062,1.062,0,0,1,1.062-1.062h6.8a1.062,1.062,0,0,1,1.062,1.062v6.8A1.062,1.062,0,0,1,370.3,301.551Z"
                transform="translate(-301.021 -241.61)"
                fill="#f0324c"
              />
              <g id="Group_69" data-name="Group 69">
                <circle
                  id="Ellipse_226"
                  data-name="Ellipse 226"
                  cx="15.187"
                  cy="15.187"
                  r="15.187"
                  transform="translate(55.139 1.07)"
                  fill="#fff"
                />
                <path
                  id="Path_671"
                  data-name="Path 671"
                  d="M159.876,68.686a16.178,16.178,0,0,0-2.721-9,1.062,1.062,0,0,0-1.768,1.178,14.144,14.144,0,1,1-4.12-4.055,1.062,1.062,0,0,0,1.151-1.785,16.237,16.237,0,0,0-22.251,4.561h-53.7a3.189,3.189,0,0,0-3.186,3.186v49.977a1.062,1.062,0,0,0,2.124,0V62.77a1.063,1.063,0,0,1,1.062-1.062h52.479A16.243,16.243,0,0,0,148.774,84.1V134.01a1.063,1.063,0,0,1-1.062,1.062H76.473a1.063,1.063,0,0,1-1.062-1.062v-15.05a1.062,1.062,0,0,0-2.124,0v15.05a3.189,3.189,0,0,0,3.186,3.186h71.239a3.189,3.189,0,0,0,3.186-3.186v-50.8a16.266,16.266,0,0,0,8.978-14.526Z"
                  transform="translate(-73.287 -52.435)"
                  fill="#2f3042"
                />
              </g>
            </g>
            <g id="Group_71" data-name="Group 71">
              <path
                id="Path_672"
                data-name="Path 672"
                d="M313.075,31.884a3.077,3.077,0,1,1,2.177-.9A3.069,3.069,0,0,1,313.075,31.884Zm0-4.033a.955.955,0,1,0,.676.28A.953.953,0,0,0,313.075,27.851Z"
                transform="translate(-250.658 -25.728)"
                fill="#f0324c"
              />
              <path
                id="Path_673"
                data-name="Path 673"
                d="M455.067,223.741a3.08,3.08,0,1,1,2.177-5.257h0a3.08,3.08,0,0,1-2.178,5.257Zm0-4.035a.955.955,0,1,0,.676.279A.954.954,0,0,0,455.067,219.706Z"
                transform="translate(-362.492 -176.836)"
                fill="#f0324c"
              />
              <path
                id="Path_674"
                data-name="Path 674"
                d="M35.7,226.468a1.058,1.058,0,0,1-.751-.311l-1.267-1.267-1.267,1.267a1.062,1.062,0,0,1-1.5-1.5l2.018-2.018a1.062,1.062,0,0,1,1.5,0l2.018,2.018a1.062,1.062,0,0,1-.751,1.813Z"
                transform="translate(-30.602 -180.573)"
                fill="#f0324c"
              />
              <path
                id="Path_675"
                data-name="Path 675"
                d="M253.551,47.508a1.058,1.058,0,0,1-.751-.311l-1.267-1.267L250.267,47.2a1.062,1.062,0,0,1-1.5-1.5l2.018-2.018a1.062,1.062,0,0,1,1.5,0L254.3,45.7a1.062,1.062,0,0,1-.751,1.813Z"
                transform="translate(-202.186 -39.621)"
                fill="#f0324c"
              />
              <path
                id="Path_676"
                data-name="Path 676"
                d="M322.968,470.914a1.058,1.058,0,0,1-.751-.311l-1.267-1.267-1.267,1.267a1.062,1.062,0,0,1-1.5-1.5l2.018-2.018a1.062,1.062,0,0,1,1.5,0l2.018,2.018a1.062,1.062,0,0,1-.751,1.813Z"
                transform="translate(-256.86 -373.102)"
                fill="#f0324c"
              />
            </g>
          </g>
          <path
            id="Path_677"
            data-name="Path 677"
            d="M384.932,95.061a1.911,1.911,0,0,0-2.7,0l-3.745,3.745-3.745-3.745a1.911,1.911,0,0,0-2.7,2.7l3.745,3.745-3.745,3.745a1.911,1.911,0,1,0,2.7,2.7l3.745-3.745,3.745,3.745a1.911,1.911,0,0,0,2.7-2.7l-3.745-3.745,3.745-3.745A1.911,1.911,0,0,0,384.932,95.061Z"
            transform="translate(-299.08 -79.895)"
            fill="#f0324c"
          />
        </g>
        <g id="Group_80" data-name="Group 80" transform="translate(20.958 62.778)">
          <g id="Group_76" data-name="Group 76">
            <g id="Group_74" data-name="Group 74" transform="translate(2.124)">
              <path
                id="Path_678"
                data-name="Path 678"
                d="M144.292,323.44h-3.947a1.062,1.062,0,0,1,0-2.124h3.947a1.062,1.062,0,0,1,0,2.124Z"
                transform="translate(-139.283 -321.316)"
                fill="#2f3042"
              />
            </g>
            <g id="Group_75" data-name="Group 75" transform="translate(0 3.679)">
              <path
                id="Path_679"
                data-name="Path 679"
                d="M136.416,340.761h-6.071a1.062,1.062,0,0,1,0-2.124h6.071a1.062,1.062,0,0,1,0,2.124Z"
                transform="translate(-129.283 -338.637)"
                fill="#2f3042"
              />
            </g>
          </g>
          <g id="Group_79" data-name="Group 79" transform="translate(0 9.682)">
            <g id="Group_77" data-name="Group 77">
              <path
                id="Path_680"
                data-name="Path 680"
                d="M136.416,369.029h-6.071a1.062,1.062,0,0,1,0-2.124h6.071a1.062,1.062,0,0,1,0,2.124Z"
                transform="translate(-129.283 -366.905)"
                fill="#2f3042"
              />
            </g>
            <g id="Group_78" data-name="Group 78" transform="translate(0 3.679)">
              <path
                id="Path_681"
                data-name="Path 681"
                d="M136.416,386.351h-6.071a1.062,1.062,0,1,1,0-2.124h6.071a1.062,1.062,0,0,1,0,2.124Z"
                transform="translate(-129.283 -384.227)"
                fill="#2f3042"
              />
            </g>
          </g>
        </g>
        <g id="Group_81" data-name="Group 81" transform="translate(39.215 12.822)">
          <path
            id="Path_682"
            data-name="Path 682"
            d="M230.431,113.288H217.366a2.126,2.126,0,0,1-2.124-2.124V86.1h17.313v25.065A2.126,2.126,0,0,1,230.431,113.288ZM217.366,88.223v22.941h13.066V88.223H217.366Z"
            transform="translate(-215.242 -86.099)"
            fill="#2f3042"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-24'
    },
    height: {
      type: String,
      default: 'h-24'
    }
  }
}
</script>
